import { asyncAction, newSetLoginState } from "@awe-web/shared/lib";
import { getRentContract } from "@awe-web/shared/lib";
import {
  loadTariffOptions,
  loadRentContractData,
  setTariffOptionId,
  setDeductibleOption,
  setRentObjectProperties
} from "../../../rent_contracts/actions.js";
import { B2C_LTR_SelectProvisioning } from "../../../routing/routes.js";

export const initialize = () => async (dispatch, getState, context) => {
  await dispatch(newSetLoginState()());

  return await dispatch(loadRentContractData({
    reservationPath: "B2C",
    additionalAction: (rentContract) => async (dispatch) => {
      await dispatch(loadTariffOptions(rentContract.id));
    }
  }));
};

export const submit = (formValues) => async (dispatch, getState) => {
  const rentContract = getRentContract(getState());
  const rentContractJs = rentContract.toJS();
  const rentContractId = rentContract.get("id");
  const {
    mileage: tariffOptionId,
    deductible: deductibleId,
    equipment: rentObjectPropertiesMap
  } = formValues;

  await dispatch(asyncAction({
    typePrefix: "SELECT_EXTRAS/UPDATE_RENT_CONTRACT",
    loadPayload: async () => {
      // rentcontract/update cannot be performed in parallel
      await dispatch(setTariffOptionId(rentContractId, tariffOptionId));
      await Promise.all([
        dispatch(setDeductibleOption(rentContractJs, deductibleId)),
        dispatch(setRentObjectProperties(rentContractJs, rentObjectPropertiesMap))
      ]);
    }
  }));

  return B2C_LTR_SelectProvisioning.path();
};
